import React from "react";
import cx from "classnames";

import { getTestAttributes } from "@common/utils/tests";
import { SkipLogicCondition } from "@common/components/skip-logic/skip-logic.types";
import { SkipLogicConditionCreateDto } from "@common/components/skip-logic/skip-logic.types";
import { Cell } from "./components/cell";

import "./row.styles.scss";

type RowProps = {
  condition: SkipLogicCondition;
  conditionIndex: number;
  onClick: (condition: SkipLogicCondition) => void;
  selectedRow: boolean;
  columns: Array<{
    label: string;
    fieldName: keyof SkipLogicConditionCreateDto;
    component: (condition: SkipLogicCondition) => React.ReactNode;
  }>;
};

export const Row: React.FC<RowProps> = ({ condition, onClick, columns, conditionIndex, selectedRow }) => {
  const handleClick = React.useCallback(() => {
    onClick(condition);
  }, [onClick, condition]);

  return (
    <tr
      className={cx("SkipLogic__row", {
        ["SkipLogic__row--selected"]: selectedRow,
      })}
      {...getTestAttributes({
        id: `pan-query-fields-data-tbody-row${conditionIndex}`,
      })}
      key={condition.id}
      onClick={handleClick}
    >
      <Cell
        testAttributes={getTestAttributes({
          id: `pan-query-fields-data-tbody-row${conditionIndex}-cell0`,
        })}
      >
        <img src={condition.field.imageURL} height={20} />
      </Cell>

      {columns.map((column, columnIndex) => (
        <Cell
          key={column.fieldName}
          testAttributes={getTestAttributes({
            id: `pan-query-fields-data-tbody-row${conditionIndex}-cell${columnIndex + 1}`,
          })}
        >
          {column.component(condition)}
        </Cell>
      ))}
    </tr>
  );
};
